import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';
import { LIST_CAROUSEL_BANNER } from '../../apiCalls/urls/homePage';
import { LIST_EVENTS } from '../../apiCalls/urls/events';
import { GET_LIST } from '../../apiCalls/urls/common';
export const homePageApi = createApi({
    baseQuery,
    tagTypes: ['homePage'],
    reducerPath: 'homePageApi',
    endpoints: (builder) => ({
        getHomepageCarouselList: builder.query({
            query: (bodyData) => ({
                url: LIST_CAROUSEL_BANNER,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['homePage'],
            refetchOnMountOrArgChange: true,
        }),
        getHomepageEventsList: builder.query({
            query: (bodyData) => ({
                url: LIST_EVENTS,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['homePage'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetHomepageCarouselListQuery,
    useGetHomepageEventsListQuery,
    useGetListMutation
} = homePageApi;